<template>
    <div v-if="isActive">
        <slot></slot>
    </div>
</template>

<script>

export default {
  name: 'Tab',
  props: {
    name: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    new: {
      type: Boolean,
      default: false,
    },
    gacategory: {
      type: String,
      required: false,
      default: 'Dezi Component - Tabs',
    },
    gaaction: {
      type: String,
      required: false,
      default: null,
    },
    galabel: {
      type: String,
      required: false,
      default: null,
    },
    gapageview: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    href() {
      return `#${this.name.toLowerCase().replace(/ /g, '-')}`;
    },
    getGaAction() {
      return this.gaaction || `Click Tab - ${this.name}`;
    },
  },
  mounted() {
    this.isActive = this.selected;
  },
};
</script>

<style scoped>
</style>
